import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'

const defaultParams = {
  from: moment().format('YYYY-MM-DD'),
  to: moment().add(30, 'days').format('YYYY-MM-DD'),
}
const module = 'bookingsview'
let doc = {
  list: {
    name: 'Réservations',
    hasMap: true,
    headers: [
      { label: 'En affichage', value: 'inUse', orig: 'current_display_id' },
      { label: 'Client', value: 'client' },
      { label: 'Code', value: 'code' },
      { label: 'Type', value: 'board_type', truncate: true },
      { label: 'Adresse', value: 'adress' },
      { label: 'District', value: 'district' },
      { label: 'Ville', value: 'city' },
      { label: 'Région', value: 'region' },
      { label: 'Début', value: 'dateStart', orig: 'date_start', card: false },
      { label: 'Fin', value: 'dateEnd', orig: 'date_end', card: false },
      { label: 'Dates', value: 'dates', sortable: false, inTable: false },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    search: [
      { label: 'Début', type: 'date', name: 'from', classes: 'md6' },
      { label: 'Fin', type: 'date', name: 'to', classes: 'md6' },
      { label: 'Client', type: 'multilist', name: 'client_id', from: 'name', source: 'clients' },
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities' },
      { label: 'District', type: 'multilist', name: 'district_id', from: 'name', source: 'districts' },
    ],
  },

  form: {},

  postprocess: item => {
    let inUse = item.current_display_id ? 'Oui' : 'Non'
    let dateStart = moment(item.date_start).format('DD/MM/YYYY')
    let dateEnd = moment(item.date_end).format('DD/MM/YYYY')
    let position = {lng: parseFloat(item.lon), lat: parseFloat(item.lat)}
    return {
      ...item,
      dateStart,
      dateEnd,
      dates: `${dateStart} - ${dateEnd}`,
      position,
      inUse,
    }
  },

  params: {
    fetchAll: defaultParams,
    fetchOne: {},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  state: {
    search: {
      data: defaultParams,
    },
  },
}

export default merge(base, custom)
